import { render } from "./ServiceSection.vue?vue&type=template&id=504c809f"
const script = {}

import "./ServiceSection.vue?vue&type=style&index=0&id=504c809f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__